import { denormalize, normalize, schema } from 'normalizr';

const interfaceSchema = new schema.Entity(
  'Interface',
  {},
  {
    idAttribute: 'Interface_GUID'
  }
);

const interfaceGetSchema = new schema.Entity(
  'Transaction',
  {
    Interface: interfaceSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const interfaceProcessSchema = new schema.Entity(
  'Transaction',
  {
    Interface: interfaceSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    InterfaceGet: interfaceGetSchema,
    InterfaceProcess: interfaceProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    InterfaceGet: interfaceGetSchema,
    InterfaceProcess: interfaceProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
